import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import config from "../../hoa-config";

const DropdownOrgSelection = ({ value, handleChange }: any) => {
	return (
		<FormControl sx={{ width: "250px" }}>
			<InputLabel id="dropdown-label">Select Organization</InputLabel>
			<Select value={value} label="Select Organization" onChange={handleChange}>
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
				{config.hoaOrganizations.map((org: { name: string; id: string }) => {
					return <MenuItem value={org.id}>{org.name}</MenuItem>;
				})}
			</Select>
		</FormControl>
	);
};

export default DropdownOrgSelection;
